// Pre-defined role templates for quick setup
export const roleTemplates = {
  admin: {
    name: 'Administrator',
    description: 'Full system access with all permissions',
    permissions: {
      // User Management
      viewUsers: true,
      inviteUsers: true,
      editUsers: true,
      deleteUsers: true,
      viewUserGroups: true,
      createUserGroups: true,
      editUserGroups: true,
      deleteUserGroups: true,
      viewRoles: true,
      createRoles: true,
      editRoles: true,
      deleteRoles: true,
      viewGIS: true,
      imports: true,
      // Meeting Management
      createMeetings: true,
      joinMeetings: true,
      editMeetings: true,
      viewTranscripts: true,
      viewSummaries: true,
      // Administrative
      userManagement: true,
      organizationSettings: true,
      billingAccess: true,
      // Security
      viewAuditLogs: true,
      // Teams
      viewTeams: true,
      createTeams: true,
      manageTeams: true,
      joinTeams: true,
      // Playbooks
      viewPlaybooks: true,
      createPlaybooks: true,
      editPlaybooks: true,
      deletePlaybooks: true,
      archivePlaybooks: true,
    },
  },
  manager: {
    name: 'Manager',
    description: 'Manage teams and view reports',
    permissions: {
      // User Management
      viewUsers: true,
      inviteUsers: true,
      editUsers: true,
      deleteUsers: false,
      viewUserGroups: true,
      createUserGroups: true,
      editUserGroups: true,
      deleteUserGroups: false,
      viewRoles: true,
      createRoles: false,
      editRoles: false,
      deleteRoles: false,
      viewGIS: true,
      imports: true,
      // Meeting Management
      createMeetings: true,
      joinMeetings: true,
      editMeetings: true,
      viewTranscripts: true,
      viewSummaries: true,
      // Administrative
      userManagement: false,
      organizationSettings: false,
      billingAccess: false,
      // Security
      viewAuditLogs: true,
      // Teams
      viewTeams: true,
      createTeams: true,
      manageTeams: true,
      joinTeams: true,
      // Playbooks
      viewPlaybooks: true,
      createPlaybooks: true,
      editPlaybooks: true,
      deletePlaybooks: false,
      archivePlaybooks: true,
    },
  },
  editor: {
    name: 'Editor',
    description: 'Create and edit content',
    permissions: {
      // User Management
      viewUsers: true,
      inviteUsers: false,
      editUsers: false,
      deleteUsers: false,
      viewUserGroups: true,
      createUserGroups: false,
      editUserGroups: false,
      deleteUserGroups: false,
      viewRoles: true,
      createRoles: false,
      editRoles: false,
      deleteRoles: false,
      viewGIS: true,
      imports: true,
      // Meeting Management
      createMeetings: true,
      joinMeetings: true,
      editMeetings: true,
      viewTranscripts: true,
      viewSummaries: true,
      // Administrative
      userManagement: false,
      organizationSettings: false,
      billingAccess: false,
      // Security
      viewAuditLogs: false,
      // Teams
      viewTeams: true,
      createTeams: false,
      manageTeams: false,
      joinTeams: true,
      // Playbooks
      viewPlaybooks: true,
      createPlaybooks: true,
      editPlaybooks: true,
      deletePlaybooks: false,
      archivePlaybooks: false,
    },
  },
  viewer: {
    name: 'Viewer',
    description: 'Read-only access to most features',
    permissions: {
      // User Management
      viewUsers: true,
      inviteUsers: false,
      editUsers: false,
      deleteUsers: false,
      viewUserGroups: true,
      createUserGroups: false,
      editUserGroups: false,
      deleteUserGroups: false,
      viewRoles: true,
      createRoles: false,
      editRoles: false,
      deleteRoles: false,
      viewGIS: true,
      imports: false,
      // Meeting Management
      createMeetings: false,
      joinMeetings: true,
      editMeetings: false,
      viewTranscripts: true,
      viewSummaries: true,
      // Administrative
      userManagement: false,
      organizationSettings: false,
      billingAccess: false,
      // Security
      viewAuditLogs: false,
      // Teams
      viewTeams: true,
      createTeams: false,
      manageTeams: false,
      joinTeams: false,
      // Playbooks
      viewPlaybooks: true,
      createPlaybooks: false,
      editPlaybooks: false,
      deletePlaybooks: false,
      archivePlaybooks: false,
    },
  },
  meetingOrganizer: {
    name: 'Meeting Organizer',
    description: 'Focused on meeting management and coordination',
    permissions: {
      // User Management
      viewUsers: true,
      inviteUsers: false,
      editUsers: false,
      deleteUsers: false,
      viewUserGroups: true,
      createUserGroups: false,
      editUserGroups: false,
      deleteUserGroups: false,
      viewRoles: false,
      createRoles: false,
      editRoles: false,
      deleteRoles: false,
      viewGIS: false,
      imports: false,
      // Meeting Management
      createMeetings: true,
      joinMeetings: true,
      editMeetings: true,
      viewTranscripts: true,
      viewSummaries: true,
      // Administrative
      userManagement: false,
      organizationSettings: false,
      billingAccess: false,
      // Security
      viewAuditLogs: false,
      // Teams
      viewTeams: true,
      createTeams: false,
      manageTeams: false,
      joinTeams: true,
      // Playbooks
      viewPlaybooks: false,
      createPlaybooks: false,
      editPlaybooks: false,
      deletePlaybooks: false,
      archivePlaybooks: false,
    },
  },
  guest: {
    name: 'Guest',
    description: 'Minimal access for external collaborators',
    permissions: {
      // User Management
      viewUsers: false,
      inviteUsers: false,
      editUsers: false,
      deleteUsers: false,
      viewUserGroups: false,
      createUserGroups: false,
      editUserGroups: false,
      deleteUserGroups: false,
      viewRoles: false,
      createRoles: false,
      editRoles: false,
      deleteRoles: false,
      viewGIS: false,
      imports: false,
      // Meeting Management
      createMeetings: false,
      joinMeetings: true,
      editMeetings: false,
      viewTranscripts: false,
      viewSummaries: true,
      // Administrative
      userManagement: false,
      organizationSettings: false,
      billingAccess: false,
      // Security
      viewAuditLogs: false,
      // Teams
      viewTeams: false,
      createTeams: false,
      manageTeams: false,
      joinTeams: false,
      // Playbooks
      viewPlaybooks: false,
      createPlaybooks: false,
      editPlaybooks: false,
      deletePlaybooks: false,
      archivePlaybooks: false,
    },
  },
}

// Helper function to apply a template to form data
export const applyRoleTemplate = templateKey => {
  const template = roleTemplates[templateKey]
  if (!template) return null

  const formData = {
    name: '', // User should provide their own name
    description: template.description,
  }

  // Convert template permissions to form data format
  Object.keys(template.permissions).forEach(key => {
    formData[key] = template.permissions[key]
  })

  return formData
}

// Get template options for dropdown
export const getTemplateOptions = () => {
  return Object.keys(roleTemplates).map(key => ({
    value: key,
    label: roleTemplates[key].name,
    description: roleTemplates[key].description,
  }))
}
